import http from './httpService';
//import {apiUrl} from './../config/config.json';
const apiUrl = process.env.REACT_APP_API_URL;
const apiEndpoint = apiUrl + '/labels';


function labelUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getLabels() {
  return http.get(apiEndpoint);
}

export function getLabel(Id) {
  return http.get(labelUrl(Id));
}

export function saveLabel(label) {
  //clone
  const body = { ...label };
  //update
  if (label._id) {
    //delete _id
    delete body._id;
    return http.put(labelUrl(label._id), body);
  }

  //add a new label
  return http.post(apiEndpoint, label);
}

//delete labels
export function deleteLabel(Id) {
  return http.delete(labelUrl(Id));
}  